import React from "react";
import {Controller} from "react-hook-form";
import {Autocomplete, Box, Chip, TextField, Tooltip} from "@mui/material";
import {Info} from "@mui/icons-material";

export default function ReactHookFormChipInput(
    {
        name, label, placeholder, control, rules,
        values = [],
        defaultValue = [],
        updateOnChange = () => null,
        inputLabelShrink = true,
        infoButtonText = "Press ENTER to add value"
    }
) {
    const labelId = `${name}-label`;
    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    open={false}
                    openOnFocus={false}
                    multiple
                    id={labelId}
                    options={values.map((i) => i)}
                    defaultValue={defaultValue}
                    freeSolo
                    fullWidth={true}
                    renderValue={(selected, getTagProps) =>
                        selected?.map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return (
                                <Chip
                                    key={key}
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    sx={{
                                        userSelect: "unset",
                                        "& .MuiChip-label": {
                                            userSelect: "unset"
                                        }
                                    }}
                                    label={option}
                                    {...tagProps}
                                />
                            );
                        })
                    }
                    renderInput={(params) => (
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <TextField
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    label={label}
                                    placeholder={placeholder}
                                    slotProps={{
                                        inputLabel: {
                                            shrink: inputLabelShrink
                                        }
                                    }}
                                />
                            </Box>
                            <Box p={1}>
                                <Box sx={{paddingTop: "2px", cursor: "pointer", paddingLeft: "6px"}}>
                                    <Tooltip disableFocusListener
                                             title={infoButtonText}>
                                        <Info color={"primary"} fontSize={"small"}/>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    onChange={(e, data) => {
                        onChange(data);
                        updateOnChange();
                    }}
                    {...props}
                />
            )}
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
        />
    );
}
